// app/src/srt-help.js

import { GLOSSARY } from './srt-glossary-definitions.js';

$(function () {
   console.log('Glossary.');
   populateGlossary();
});

function typeLabel(inputType) {
   switch (inputType) {
      case 'user':
         return '(User supplied)';
      case 'calculated':
         return '(Calculated)';
   }
   return '';
}

function populateGlossary() {
   const container = document.getElementById('glossary-container');

   // --- Group by section ---
   const sections = {};
   for (const [key, entry] of Object.entries(GLOSSARY)) {
      if (!sections[entry.section]) sections[entry.section] = [];
      sections[entry.section].push({ key, ...entry });
   }

   for (const [sectionName, entries] of Object.entries(sections)) {
      const sectionDiv = document.createElement('section');
      sectionDiv.classList.add('mb-5', 'border-top', 'pt-4');

      const heading = document.createElement('h4');
      heading.classList.add('mb-3');
      heading.textContent = sectionName;
      sectionDiv.appendChild(heading);

      for (const entry of entries) {
         const entryDiv = document.createElement('div');
         entryDiv.classList.add('mb-4');

         const title = document.createElement('h5');
         title.classList.add('mb-1', 'glossary-entry-title');
         title.innerHTML = `${entry.title}`;
         entryDiv.appendChild(title);

         if (entry.short) {
            const short = document.createElement('p');
            short.classList.add('text-muted', 'fst-italic', 'mb-1');
            short.textContent = `${entry.short} ${typeLabel(entry.inputType)}`;
            entryDiv.appendChild(short);
         }

         if (entry.long) {
            const long = document.createElement('p');
            long.innerHTML = entry.long;
            entryDiv.appendChild(long);
         }

         if (Array.isArray(entry.figures)) {
            const figRow = document.createElement('div');
            figRow.classList.add('row', 'gy-3');
            entry.figures.forEach((src) => {
               const col = document.createElement('div');
               col.classList.add('col-md-6');
               const img = document.createElement('img');
               img.src = src;
               img.alt = `${entry.title} diagram`;
               img.classList.add('img-fluid', 'border', 'rounded', 'glossary-img');
               col.appendChild(img);
               figRow.appendChild(col);
            });
            entryDiv.appendChild(figRow);
         }

         sectionDiv.appendChild(entryDiv);
      }

      container.appendChild(sectionDiv);
   }
}
